/**
 * @description 迟发率
 *
 * @props {string} 
 *
 * @slot {插槽} 
 *
 */
<template>
  <div class="content">
    <div class="title">
      <span class="rate">迟发率</span>
      <span class="target">目标：低于 4%</span>
    </div>
    <div class="main">
      <div class="detalis1">
        <div class="item-cell date">
          <span class="day">时间范围：{{ lateShipment[0].duration }}天</span>
          <span>{{ lateShipment[0].timeFrameStart | convertToDate }} - {{ lateShipment[0].timeFrameEnd | convertToDate}}</span>
        </div>
        <div class="item-cell rate" :class="{abnormal: !lateShipment[0].completeTarget}">{{ lateShipment[0].rate }}</div>
        <div class="item-cell">
          <span>发货延迟的订单数：</span>
          <span>{{ lateShipment[0].count }}</span>
        </div>
        <div class="item-cell">
          <span>订单总数：</span>
          <span>{{ lateShipment[0].totalCount }}</span>
        </div>
      </div>
      <div class="detalis2">
        <div class="item-cell date">
          <span class="day">时间范围：{{ lateShipment[1].duration }}天</span>
          <span>{{ lateShipment[1].timeFrameStart | convertToDate }} - {{ lateShipment[1].timeFrameEnd | convertToDate}}</span>
        </div>
        <div class="item-cell rate" :class="{abnormal: !lateShipment[1].completeTarget}">{{ lateShipment[1].rate }}</div>
        <div class="item-cell">
          <span>发货延迟的订单数：</span>
          <span>{{ lateShipment[1].count }}</span>
        </div>
        <div class="item-cell">
          <span>订单总数：</span>
          <span>{{ lateShipment[1].totalCount }}</span>
        </div>
      </div>
      <div class="message" v-if="explain">
        <div class="message-cell" v-for="(item, index) in message" :key="index">{{ item }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { convertToDate } from "@/utils/date.util"
export default {
  props: {
    explain: {
      type: Boolean,
      default: true
    },
    lateShipment: {
      default: () => []
    }
  },
  data() {
    return {
      message: [
        "迟发率(LSR)是在10天或30天的时间段内，在预计配送时间之后确认配送的所有订单数占订单总数的百分比。LSR仅适用于卖家自配送订单。 ",
        "在预计发货日期之前确认订单发货十分重要，这样买家才能在线查看他们的已发货订单的状态。订单延迟确认发货可能会导致索赔、负面反馈和/或买家联系次数增加，并对买家体验产生负面影响。 ",
        "亚马逊的政策规定，卖家需维持低于 4% 的 LSR ，才能在亚马逊上销售商品。 高于 4% 的 LSR 可能会导致账户停用。",
      ],
    };
  },
  filters: {
    convertToDate(val) {
      if (!val) { return "" }
      return convertToDate(new Date(val))
    }
  }
};
</script>

<style scoped lang="scss">
.abnormal {
  color: #F56C6C !important;
}
.content {
  line-height: 1;
  padding-bottom: 40px;
  .title {
    padding: 20px 0;
    .rate {
      padding: 0 15px 0 20px;
      color: #333;
      font-size: 16px;
      font-weight: 600;
    }
    .target {
      color: #666;
      font-size: 12px;
    }
  }
  .main {
    display: flex;
    .detalis1,
    .detalis2 {
      width: 30%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #666;
      .item-cell {
        width: 180px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-left: 40px;
        padding-bottom: 22px;
        &.rate {
          font-size: 24px;
          color: #333;
          font-weight: 600;
          padding: 10px 0 22px 40px;
        }
        &.date {
          width: 250px;
          font-size: 12px;
          padding-left: 0;
          .day {
            padding-right: 15px;
          }
        }
        &:last-child {
          padding-bottom: 0;
        }
      }
    }
    .detalis2 {
      border-left: 1px solid #ccc;
    }
    .message {
      border-left: 1px solid #ccc;
      width: 40%;
      font-size: 12px;
      color: #666;
      line-height: 20px;
      padding-right: 26px;
      padding-left: 30px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
    }
  }
}
</style>